import React from "react";
import Modal from "react-modal";
//import Loading from "./Loading";
//import Inc from "./Include";
import './Hello.scss';

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.5)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"280px",
		minHeight:"420px",
		transform: "translate(-50%, -50%)"
	}
};

function Count ({close,isOpen,nextMembers,members}){
    const forward = ()=>{
        close();
    }

    const afterOpenModal = ()=>{
		
    }

    if(!isOpen){
        return (null);
	}
	
	const gone = members.length - nextMembers.length;

	let cl = "after";
	if( gone>0 ){
		cl = cl + " minus";
	}

    return (
		<Modal
			isOpen={isOpen}
			onRequestClose={forward}
			onAfterOpen={afterOpenModal}
			style={customStyles}
			shouldCloseOnOverlayClick={false}
		>
		<div id="hello">
			<div className="face">
				<i className="fas fa-fish"></i> ついてくる仲間の数
			</div>
            <div className="meter">
                <div className="before">{members.length}<span>人</span></div>
                <div className={cl}>{nextMembers.length}<span>人</span></div>
				{gone>0 ? (
					<div className="text">きみの選択を見て{gone}人の仲間が去る</div>
				):(
					<div className="text">きみの選択に全員が納得している</div>
				)}
            </div>
			<div className="members fade_members">
				<ol className="members fadeout">
					{members.map((value,index)=>{
						const key="m"+index;
						return (
							<li key={key}>{value}</li>
						)
					})}
				</ol>
				<ol className="members fadein">
					{nextMembers.map((value,index)=>{
						const key="nm"+index;
						return (
							<li key={key}>{value}</li>
						)
					})}
				</ol>
			</div>
            <div className="btns">
                <button
                    className="ok"
                    onClick={forward}
                >良い</button>
            </div>

		</div>
		</Modal>
	);
}

export default Count;